/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const ShopifyIcon = ({
  className,
  style: styleFromProps,
  onClick,
  color = 'white',
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={className}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6302 2.80988C15.6302 2.80988 15.359 2.88736 14.9135 3.02294C14.836 2.77114 14.7198 2.4806 14.5648 2.17069C14.0612 1.20222 13.3058 0.679248 12.4148 0.679248C12.3567 0.679248 12.2986 0.679248 12.2211 0.698617C12.2018 0.659878 12.163 0.640509 12.1437 0.60177C11.7563 0.175643 11.2527 -0.0180506 10.6522 0.00131883C9.49005 0.0400576 8.32789 0.872942 7.39816 2.36439C6.7396 3.41033 6.23599 4.72745 6.10041 5.75403C4.76392 6.16079 3.83419 6.45133 3.81482 6.4707C3.13689 6.68376 3.11752 6.70313 3.04004 7.34232C2.98194 7.82656 1.19995 21.4626 1.19995 21.4626L15.8432 24V2.79051C15.727 2.79051 15.6689 2.80988 15.6302 2.80988ZM12.2405 3.85583C11.4657 4.08826 10.6135 4.35943 9.78059 4.61124C10.013 3.70087 10.4779 2.79051 11.0202 2.19006C11.2333 1.977 11.5238 1.7252 11.8531 1.57024C12.1824 2.26754 12.2599 3.21664 12.2405 3.85583ZM10.6522 0.795464C10.9234 0.795464 11.1558 0.853572 11.3495 0.969789C11.0396 1.12474 10.7297 1.37655 10.4392 1.66709C9.70312 2.46123 9.1414 3.70087 8.90897 4.88241C8.21167 5.09547 7.51437 5.30853 6.87518 5.50223C7.30131 3.64277 8.87023 0.834203 10.6522 0.795464ZM8.40537 11.4486C8.48284 12.6883 11.7563 12.9594 11.95 15.8842C12.0856 18.1892 10.7297 19.7581 8.77339 19.8743C6.41032 20.0293 5.11257 18.6347 5.11257 18.6347L5.61617 16.504C5.61617 16.504 6.91392 17.4919 7.95987 17.4144C8.6378 17.3757 8.8896 16.814 8.87023 16.4266C8.77339 14.7995 6.10041 14.8964 5.92608 12.2234C5.77113 9.97656 7.2432 7.71034 10.4973 7.49728C11.7563 7.4198 12.3955 7.72971 12.3955 7.72971L11.6594 10.5189C11.6594 10.5189 10.8265 10.1315 9.8387 10.209C8.40537 10.3058 8.386 11.2162 8.40537 11.4486ZM13.0153 3.6234C13.0153 3.04231 12.9378 2.20943 12.6666 1.51213C13.5576 1.68646 13.9838 2.6743 14.1774 3.27475C13.8288 3.37159 13.4414 3.48781 13.0153 3.6234Z"
        fill={color}
      />
      <path
        d="M16.2887 23.9613L22.3707 22.4505C22.3707 22.4505 19.7558 4.76619 19.7364 4.64998C19.7171 4.53376 19.6202 4.45628 19.5234 4.45628C19.4265 4.45628 17.722 4.41755 17.722 4.41755C17.722 4.41755 16.6761 3.41034 16.2887 3.02295V23.9613Z"
        fill={color}
      />
    </svg>
  );
};
